import React from 'react';
import { AdminRouteName } from '../../CONSTANTS';
import CustomerTableRecords from '../CustomerTableRecords';

const ProspectiveCustomers = () => (
  <CustomerTableRecords defaultUrl={AdminRouteName.prospectiveCustomersRoute} toggleStorageId="all_customer-table-col" hasNameAndImage permissionName="can-view-all-customer-tab" tabStatus="prospective" />
);
export default ProspectiveCustomers;
